// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3mEvT","right":"styles_right__1ru8R"};